import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/transactions',
    name: 'transactionData',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'transactionDataList',
        component: () => import('../pages/TransactionDataListPage.vue')
      }
    ]
  }
];

export default routes;
